import {NavigateToScreenRequest} from '@ui-tool/core';
import {ScreenCodes} from '@mobile-data-access-enums';

export class PaxmanMemberNavigationRequest extends NavigateToScreenRequest<void> {

    //#region Constructor

    public constructor() {
        super(ScreenCodes.PAXMAN_MEMBER);
    }

    //#endregion

}
